import { render, staticRenderFns } from "./ClassifierValueEdit.vue?vue&type=template&id=30a24781&lang=pug&"
import script from "./ClassifierValueEdit.vue?vue&type=script&lang=js&"
export * from "./ClassifierValueEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports